import { DeleteOutline } from '@mui/icons-material';
import { Box, Button, MenuItem, TableCell, TableRow } from '@mui/material';
import {
  Control,
  Controller,
  FieldArray,
  FieldErrors,
  UseFormRegister,
} from 'react-hook-form';

import { FSDateField } from '@/ui/components/input/FSDateField';
import { FSPositionGeocodeField } from '@/ui/components/input/FSPositionGeocodeField';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { isNumber } from '@/ui/utils/form-validations';

import {
  defaultTourEventFormValues,
  TourEventsFormValues,
  typeOptions,
} from '../tour-event-form-values/TourEventsFormValues';

export function AddTourEventsTableBodyRow({
  index,
  // eslint-disable-next-line unused-imports/no-unused-vars
  field,
  control,
  register,
  errors,
  onClickDelete,
}: {
  index: number;
  field: FieldArray<TourEventsFormValues>;
  control: Control<TourEventsFormValues>;
  register: UseFormRegister<TourEventsFormValues>;
  errors: FieldErrors<TourEventsFormValues>;
  onClickDelete: () => void;
}) {
  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell sx={{ maxWidth: 200 }}>
        <Controller
          name={`tourEvents.${index}.date`}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <FSDateField
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              error={!!errors.tourEvents?.[index]?.date}
              helperText={errors.tourEvents?.[index]?.date?.message}
            />
          )}
        />
      </TableCell>
      <TableCell sx={{ maxWidth: 200 }}>
        <FSTextField
          register={{
            ...register(`tourEvents.${index}.name`, {
              required: true,
            }),
          }}
          error={!!errors.tourEvents?.[index]?.name}
          helperText={errors.tourEvents?.[index]?.name?.message}
        />
      </TableCell>
      <TableCell sx={{ minWidth: 250 }}>
        <Controller
          name={`tourEvents.${index}.position`}
          control={control}
          rules={{ required: true }}
          defaultValue={defaultTourEventFormValues.position}
          render={({ field }) => (
            <FSPositionGeocodeField
              placeholder={translate(
                'ProjectsTour.AddTourEventsModal.position-placeholder',
              )}
              value={field.value}
              onChange={field.onChange}
              error={!!errors.tourEvents?.[index]?.position}
              helperText={errors.tourEvents?.[index]?.position?.message}
            />
          )}
        />
      </TableCell>
      <TableCell sx={{ maxWidth: 150 }}>
        <FSTextField
          register={{
            ...register(`tourEvents.${index}.capacity`, {
              validate: isNumber,
            }),
          }}
          error={!!errors.tourEvents?.[index]?.capacity}
          helperText={errors.tourEvents?.[index]?.capacity?.message}
        />
      </TableCell>
      <TableCell sx={{ minWidth: 150 }}>
        <Controller
          name={`tourEvents.${index}.type`}
          control={control}
          defaultValue={defaultTourEventFormValues.type}
          rules={{ required: true }}
          render={({ field }) => (
            <FSTextField
              select
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              error={!!errors.tourEvents?.[index]?.type}
            >
              {typeOptions.map((value) => (
                <MenuItem key={value} value={value}>
                  {translate(`TourEventTypes.${value}`)}
                </MenuItem>
              ))}
            </FSTextField>
          )}
        />
      </TableCell>
      <TableCell sx={{ px: 0 }}>
        <Box display="flex" justifyContent="end">
          <Button onClick={onClickDelete}>
            <DeleteOutline sx={{ color: ColorsRaw.basic.White }} />
          </Button>
        </Box>
        <Box></Box>
      </TableCell>
    </TableRow>
  );
}
